module.exports = __webpack_public_path__ + "img/Sharon-CassanoLochman.7956b8d6.jpeg";